export const GET_ITEM_STATISTICAL_REPORT_LIST_START = "GET_ITEM_STATISTICAL_REPORT_LIST_START";
export const GET_ITEM_STATISTICAL_REPORT_LIST_SUCCESS = "GET_ITEM_STATISTICAL_REPORT_LIST_SUCCESS";
export const GET_ITEM_STATISTICAL_REPORT_LIST_FAILURE = "GET_ITEM_STATISTICAL_REPORT_LIST_FAILURE";

export const SEARCH_ITEM_STATISTICAL_PRODUCT_NAME = "SEARCH_ITEM_STATISTICAL_PRODUCT_NAME";

export const YEARLY_ITEM_STATISTICAL_REPORT_LIST_START = "YEARLY_ITEM_STATISTICAL_REPORT_LIST_START";
export const YEARLY_ITEM_STATISTICAL_REPORT_LIST_SUCCESS = "YEARLY_ITEM_STATISTICAL_REPORT_LIST_SUCCESS";
export const YEARLY_ITEM_STATISTICAL_REPORT_LIST_FAILURE = "YEARLY_ITEM_STATISTICAL_REPORT_LIST_FAILURE";